import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const SliderIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 21.04 20.36",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 20.36),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/jsx("path", {
        d: "m0 0h21.04v20.36h-21.04z"
      })
    }), /*#__PURE__*/jsxs("g", {
      clipPath: "url(#a)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [/*#__PURE__*/jsx("path", {
        d: "m19.82 15.5v4.36h-19v-4.36"
      }), /*#__PURE__*/jsx("path", {
        d: "m.83 4.86v-4.36h19v4.36"
      }), /*#__PURE__*/jsx("path", {
        d: "m17.18 7.5 3.36 2.51-3.33 2.74"
      }), /*#__PURE__*/jsx("path", {
        d: "m3.85 12.73-3.35-2.5 3.32-2.73"
      })]
    }), /*#__PURE__*/jsx("path", {
      d: "M.5.5h20v20H.5z"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.94 6.46a2.6 2.6 0 1 0 2.6-2.6 2.6 2.6 0 0 0-2.6 2.6zM3.28 13.2a7.1 7.1 0 0 1 10.14 3.6M12.81 14.86a3.86 3.86 0 0 1 5.07-.1"
    })]
  });
};

export { SliderIcon };
//# sourceMappingURL=slider.js.map
